import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { PortalUnits } from "@Actions/Viewer";

/**
 * Portal-wide unit settings (linear / area / volume). Fetched once via
 * `fetchUnits` and read by any component — viewer-internal or not — so
 * consumers don't depend on being inside `HoopsViewerContext.Provider`.
 */
const initialState: PortalUnits = {
  linearUnits: [],
  areaUnits: [],
  volumeUnits: [],
};

const portalUnitsSlice = createSlice({
  name: "portalUnits",
  initialState,
  reducers: {
    setPortalUnits: (_state, action: PayloadAction<PortalUnits>) => action.payload,
  },
});

export const { setPortalUnits } = portalUnitsSlice.actions;
export const portalUnits = portalUnitsSlice.reducer;
